export default {
  from: "From",
  to: "To",
  fromDate: "From Date",
  toDate: "To Date",
  getData: "Get Data",
  loading: "Loading...",
  noDataHere: "No Data Here in this range",
  departmentPerformance: "Department Performance",
};

